import { Plus, Eye, Edit, X, CreditCard } from "lucide-react";
import { Link, useParams } from "react-router";
import { useMemo } from "react";
function billingProfileHrefForCustId(rawId) {
  const custIdNum = Number.parseInt(String(rawId ?? ""), 10);
  if (!Number.isFinite(custIdNum) || custIdNum <= 0) {
    return "/billing-profile";
  }
  const params = new URLSearchParams();
  params.set("custId", String(custIdNum));
  try {
    const rawClients = localStorage.getItem("clients");
    const clientsList = rawClients ? JSON.parse(rawClients) : [];
    if (Array.isArray(clientsList)) {
      const client = clientsList.find((c) => Number(c?.id) === custIdNum);
      if (client) {
        const name = String(client.name ?? "").trim();
        const code = String(client.code ?? "").trim();
        if (name) {
          params.set("clientName", name);
        }
        if (code) {
          params.set("clientCode", code);
        }
      }
    }
  } catch {
    /* ignore */
  }
  const qs = params.toString();
  return qs ? `/billing-profile?${qs}` : "/billing-profile";
}

function POJacketManagement() {
  const { id: routeCustId } = useParams();
  const billingProfileHref = useMemo(
    () => billingProfileHrefForCustId(routeCustId),
    [routeCustId]
  );
  const purchaseOrders = [
    {
      id: 1,
      poNumber: "PO-2026-001",
      description: "Spring Campaign 2026 Services",
      startDate: "2026-01-01",
      endDate: "2026-12-31",
      status: "Active",
      numberOfJackets: 3
    },
    {
      id: 2,
      poNumber: "PO-2026-045",
      description: "Q1 Marketing Initiative",
      startDate: "2026-01-15",
      endDate: "2026-06-30",
      status: "Active",
      numberOfJackets: 5
    },
    {
      id: 3,
      poNumber: "PO-2025-234",
      description: "Annual Consulting Services",
      startDate: "2025-07-01",
      endDate: "2025-12-31",
      status: "Completed",
      numberOfJackets: 8
    }
  ];
  const jackets = [
    {
      id: 1,
      jacketNumber: "JKT-2026-001",
      brand: "Acme Brand A",
      description: "Digital Marketing Campaign",
      status: "Active",
      billingProfile: "Standard Hourly",
      poNumber: "PO-2026-001"
    },
    {
      id: 2,
      jacketNumber: "JKT-2026-002",
      brand: "Acme Brand A",
      description: "Social Media Strategy",
      status: "Active",
      billingProfile: "Standard Hourly",
      poNumber: "PO-2026-001"
    },
    {
      id: 3,
      jacketNumber: "JKT-2026-003",
      brand: "Acme Brand B",
      description: "Content Production",
      status: "Active",
      billingProfile: "Fixed Fee",
      poNumber: "PO-2026-001"
    },
    {
      id: 4,
      jacketNumber: "JKT-2026-015",
      brand: "Acme Brand A",
      description: "Email Campaign Development",
      status: "Active",
      billingProfile: "Standard Hourly",
      poNumber: "PO-2026-045"
    },
    {
      id: 5,
      jacketNumber: "JKT-2026-016",
      brand: "Acme Brand C",
      description: "Market Research Analysis",
      status: "Active",
      billingProfile: "Retainer",
      poNumber: "PO-2026-045"
    },
    {
      id: 6,
      jacketNumber: "JKT-2026-017",
      brand: "Acme Brand B",
      description: "Brand Development",
      status: "On Hold",
      billingProfile: "Standard Hourly",
      poNumber: "PO-2026-045"
    },
    {
      id: 7,
      jacketNumber: "JKT-2025-089",
      brand: "Acme Brand A",
      description: "Annual Strategy Planning",
      status: "Completed",
      billingProfile: "Fixed Fee",
      poNumber: "PO-2025-234"
    },
    {
      id: 8,
      jacketNumber: "JKT-2025-090",
      brand: "Acme Brand B",
      description: "Q4 Campaign Execution",
      status: "Completed",
      billingProfile: "Standard Hourly",
      poNumber: "PO-2025-234"
    }
  ];
  return <div className="p-8">
      {
    /* Page Title */
  }
      <div className="mb-8">
        <h1 className="text-3xl font-semibold text-gray-900 dark:text-gray-100 mb-4">
          PO and Jacket Management
        </h1>
        
        {
    /* Client Info */
  }
        <div className="flex items-center gap-6">
          <div>
            <span className="text-sm text-gray-600 dark:text-gray-400">Client Name:</span>
            <span className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-100">
              Acme Corporation
            </span>
          </div>
          <div>
            <span className="text-sm text-gray-600 dark:text-gray-400">Client Code:</span>
            <span className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-100">
              ACME
            </span>
          </div>
        </div>
      </div>

      {
    /* Section 1: Purchase Orders */
  }
      <div className="mb-8">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">Purchase Orders</h2>
          <button className="app-btn-gloss">
            <Plus className="w-5 h-5" />
            Add PO
          </button>
        </div>

        <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded shadow-sm">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 dark:bg-gray-800">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                    PO Number
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                    Description
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                    Start Date
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                    End Date
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                    Status
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                    Number of Jackets
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 dark:divide-gray-800">
                {purchaseOrders.map((po) => <tr key={po.id} className="hover:bg-gray-50 dark:hover:bg-gray-800">
                    <td className="px-6 py-4 text-sm font-medium text-gray-900 dark:text-gray-100">
                      {po.poNumber}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-900 dark:text-gray-100">
                      {po.description}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600 dark:text-gray-400">
                      {po.startDate}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600 dark:text-gray-400">
                      {po.endDate}
                    </td>
                    <td className="px-6 py-4 text-sm">
                      <span
    className={`px-2 py-1 rounded text-xs ${po.status === "Active" ? "bg-blue-600 text-white" : "bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-gray-100"}`}
  >
                        {po.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-900 dark:text-gray-100 text-center">
                      {po.numberOfJackets}
                    </td>
                    <td className="px-6 py-4 text-sm">
                      <div className="flex items-center gap-2">
                        <button
    className="app-btn-plain inline-flex items-center gap-1 px-3 py-1 text-xs border border-gray-300 dark:border-gray-700 rounded hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors bg-white dark:bg-gray-900"
    title="View Jackets"
  >
                          <Eye className="w-3 h-3 text-blue-600 dark:text-blue-400" />
                          <span className="text-gray-900 dark:text-gray-100">View Jackets</span>
                        </button>
                        <button
    className="app-btn-plain inline-flex items-center gap-1 px-3 py-1 text-xs border border-gray-300 dark:border-gray-700 rounded hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors bg-white dark:bg-gray-900"
    title="Edit"
  >
                          <Edit className="w-3 h-3 text-blue-600 dark:text-blue-400" />
                          <span className="text-gray-900 dark:text-gray-100">Edit</span>
                        </button>
                        <button
    className="app-btn-plain inline-flex items-center gap-1 px-3 py-1 text-xs border border-gray-300 dark:border-gray-700 rounded hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors bg-white dark:bg-gray-900"
    title="Close PO"
  >
                          <X className="w-3 h-3 text-blue-600 dark:text-blue-400" />
                          <span className="text-gray-900 dark:text-gray-100">Close PO</span>
                        </button>
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {
    /* Section 2: Jackets */
  }
      <div>
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">Jackets</h2>
          <button className="app-btn-gloss">
            <Plus className="w-5 h-5" />
            Add Jacket
          </button>
        </div>

        <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded shadow-sm">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 dark:bg-gray-800">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                    Jacket Number
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                    Brand
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                    Description
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                    Status
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                    Billing Profile
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 dark:divide-gray-800">
                {jackets.map((jacket) => <tr key={jacket.id} className="hover:bg-gray-50 dark:hover:bg-gray-800">
                    <td className="px-6 py-4 text-sm font-medium text-gray-900 dark:text-gray-100">
                      {jacket.jacketNumber}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-900 dark:text-gray-100">
                      {jacket.brand}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-900 dark:text-gray-100">
                      {jacket.description}
                    </td>
                    <td className="px-6 py-4 text-sm">
                      <span
    className={`px-2 py-1 rounded text-xs ${jacket.status === "Active" ? "bg-blue-600 text-white" : jacket.status === "On Hold" ? "bg-gray-300 dark:bg-gray-600 text-gray-900 dark:text-gray-100" : "bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-gray-100"}`}
  >
                        {jacket.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-900 dark:text-gray-100">
                      {jacket.billingProfile}
                    </td>
                    <td className="px-6 py-4 text-sm">
                      <div className="flex items-center gap-2">
                        <Link
    to={billingProfileHref}
    className="app-btn-plain inline-flex items-center gap-1 px-3 py-1 text-xs border border-gray-300 dark:border-gray-700 rounded hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors bg-white dark:bg-gray-900"
    title="Configure Billing"
  >
                          <CreditCard className="w-3 h-3 text-blue-600 dark:text-blue-400" />
                          <span className="text-gray-900 dark:text-gray-100">Configure Billing</span>
                        </Link>
                        <button
    className="app-btn-plain inline-flex items-center gap-1 px-3 py-1 text-xs border border-gray-300 dark:border-gray-700 rounded hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors bg-white dark:bg-gray-900"
    title="Edit Jacket"
  >
                          <Edit className="w-3 h-3 text-blue-600 dark:text-blue-400" />
                          <span className="text-gray-900 dark:text-gray-100">Edit Jacket</span>
                        </button>
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>;
}
export {
  POJacketManagement
};
